export default {
	add(itemid, type, cb, ecb) {
		this.http
			.get(`/favorite/add/${itemid}/${type}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(itemid, type, cb, ecb) {
		this.http
			.get(`/favorite/remove/${itemid}/${type}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	count(itemid, type, cb, ecb) {
		this.http
			.get(`/favorite/count/${itemid}/${type}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(itemid, type, cb, ecb) {
		this.http
			.get(`/favorite/status/${itemid}/${type}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get(`/favorite`, { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
